/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
// we need to use tabindex on popup ^^ so it could be interactable right away
// when it's appears
import React from 'react';
import PropTypes from 'prop-types';
import { handleEnterKeyPress } from '../popups/utils';

const RadioButton = ({ id, value, name, isChecked, onChange }) => (
    <label className='dashboard-radio-button' htmlFor={id}>
        <input
            id={id}
            value={value}
            type="radio"
            checked={isChecked}
            onChange={onChange}
            tabIndex={-1}
        />
        <span className='dashboard-checkmark' tabIndex={0} onKeyDown={handleEnterKeyPress} />
        <span className='dashboard-label'>{name}</span>
    </label>
);

RadioButton.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    isChecked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

RadioButton.defaultProps = {
    isChecked: false,
};

export default RadioButton;
